
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function Courses() {
  const { t } = useTranslation();
  
  const courses = [
    {
      title: t('BMX English Basics'),
      description: t('Learn fundamental English vocabulary and phrases used in BMX riding, from basic tricks to advanced techniques.'),
      image: 'https://public.readdy.ai/ai/img_res/a1af13c02a6588b9de1e35aae28bb3ba.jpg',
      level: 'Beginner',
      duration: '4 weeks',
      lessons: 12
    },
    {
      title: t('Skateboard Conversations'),
      description: t('Master conversational English through skateboarding culture, street terminology, and skate park interactions.'),
      image: 'https://readdy.ai/api/search-image?query=Skateboarders%20having%20conversations%20at%20skate%20park%2C%20street%20culture%20and%20skateboarding%20terminology%20visualization%2C%20social%20interaction%20in%20urban%20skateboarding%20environment%2C%20diverse%20group%20of%20skaters%20communicating%2C%20modern%20street%20art%20background%2C%20engaging%20conversational%20learning%20concept&width=600&height=400&seq=course-2&orientation=landscape',
      level: 'Intermediate',
      duration: '6 weeks',
      lessons: 18
    },
    {
      title: t('Action Sports Media'),
      description: t('Improve your English by analyzing action sports videos, interviews, and social media content.'),
      image: 'https://readdy.ai/api/search-image?query=Action%20sports%20media%20analysis%20with%20video%20screens%20showing%20BMX%20and%20skateboard%20content%2C%20social%20media%20interfaces%20and%20interview%20footage%2C%20digital%20media%20learning%20environment%2C%20modern%20technology%20setup%20for%20content%20analysis%2C%20engaging%20multimedia%20educational%20experience&width=600&height=400&seq=course-3&orientation=landscape',
      level: 'Advanced',
      duration: '8 weeks',
      lessons: 24
    },
    {
      title: t('Competition English'),
      description: t('Learn specialized English for competitions, judging criteria, and professional action sports communication.'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20action%20sports%20competition%20scene%20with%20judges%20and%20competitors%2C%20formal%20competition%20environment%20with%20scoring%20displays%2C%20professional%20BMX%20and%20skateboard%20contest%20atmosphere%2C%20official%20competition%20terminology%20and%20communication%2C%20high-level%20competitive%20sports%20setting&width=600&height=400&seq=course-4&orientation=landscape',
      level: 'Professional',
      duration: '10 weeks',
      lessons: 30
    }
  ];
  
  return (
    <section id="courses" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('Our Courses')}
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {courses.map((course, index) => (
            <Card key={index} hover className="overflow-hidden">
              <img 
                src={course.image} 
                alt={course.title}
                className="w-full h-64 object-cover object-center"
              />
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                    {course.level}
                  </span>
                  <div className="flex items-center text-gray-500 text-sm">
                    <i className="ri-time-line mr-1"></i>
                    {course.duration}
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {course.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {course.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-gray-500 text-sm">
                    <i className="ri-play-circle-line mr-1"></i>
                    {course.lessons} lessons
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
